<template>
  <div class="recruit_procure_wrap">
    <div class="recruit_procure_main pc_container">
      <div class="rp_box">
        <div class="rp_title">
          <span>{{procureList.info.title}}</span>
          <router-link :to="{path: '/news/index', query: {type: procureList.info.slug}}" class="more">&gt;&gt;更多</router-link>
        </div>
        <div class="rp_content">
          <div class="rp_item" v-for="(item, index) in procureList.list" :key="index" @click="$router.push({path: '/news/detail', query: {id: item.id,type: item.category.slug}})">
            <div class="rp_item_title">
              <div class="rp_item_name text-one">{{ item.title }}</div>
              <div class="rp_item_status" v-if="item.status === '报名中'" style="color: #2A59AB;">{{item.status}}</div>
              <div class="rp_item_status" v-if="item.status === '已截止'" style="color: #999;">{{item.status}}</div>
            </div>
            <div class="rp_item_time">
              <div>截止时间：{{ item.cut_time }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="rp_box">
        <div class="rp_title">
          <span>{{recruitList.info.title}}</span>
          <a :href="recruitList.info.href" target="_blank"  class="more">&gt;&gt;更多</a>
        </div>
        <div class="rp_content">
          <div class="rp_item" v-for="(item, index) in recruitList.list" :key="index" @click="toPurchase(item)">
            <div class="rp_item_title">
              <div class="rp_item_name text-one">{{ item.title }}</div>
              <div class="rp_item_status" v-if="item.status === '未开始'" style="color: #999;">{{item.status}}</div>
              <div class="rp_item_status" v-if="item.status === '报名中'" style="color: #2A59AB;">{{item.status}}</div>
              <div class="rp_item_status" v-if="item.status === '已截止'" style="color: #E6A23C;">{{item.status}}</div>
              <div class="rp_item_status" v-if="item.status === '已停标'" style="color: #f56c6c;">{{item.status}}</div>
            </div>
            <div class="rp_item_time">
              <div>发布时间：{{ item.sign_time }}</div>
              <div>报名时间：{{ item.s_time }}</div>
              <div>类型：{{ item.type_name }}</div>
              <div>截止时间：{{ item.e_time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 props: {
    procureList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    recruitList: {
      type: Object,
      default: () => {
        return {}
      }
    },
 },
  data() {
    return {
      
    }
  },
  methods: {
    toPurchase(item) {
      window.open(item.href)
    }
  },
}
</script>

<style lang="scss">
.text-one {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recruit_procure_wrap {
  padding-bottom: 30px;
  text-align: center;
  background: #fff;
  .recruit_procure_main{
    display: flex;
    justify-content: space-between;
    .rp_box{
      width: 48%;
      text-align: left;
      .rp_title{
        height: 77px;
        line-height: 77px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #E9E9E9;
        span{
          padding: 0 47px;
          background: #2A59AB;
          color: #fff;
          font-size: 18px;
        }
        .more{
          font-size: 16px;
          color: #2A59AB;
          margin-right: 36px;
        }
      }
      .rp_content{
        padding-top: 20px;
        min-height: 670px;
        .rp_item{
          margin-bottom: 20px;
          padding-right: 30px;
          padding:5px 10px;
          border-radius: 6px;
          cursor: pointer;
          &:hover{
            background-color: #f6f6f6;
          }
          .rp_item_title{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            .rp_item_name{
              color: #2A59AB;
              font-size: 16px;
              width: 90%;
            }
          }
          .rp_item_time{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            div{
              font-size: 14px;
              color: #666;
              width: 50%;
              margin-bottom: 15px;
            }
            div:nth-child(2n){
              text-align: right;
            }
          }
          .rp_item_status{
            font-size: 16px;
          }
        }

      }
    }
  }  
}
</style>